import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const readPreference = (): boolean =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(QUERY).matches
        : false;

export const usePrefersReducedMotion = (): boolean => {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(
        readPreference
    );

    useEffect(() => {
        if (
            typeof window === 'undefined' ||
            typeof window.matchMedia !== 'function'
        ) {
            return;
        }

        const mediaQueryList = window.matchMedia(QUERY);
        const handleChange = () =>
            setPrefersReducedMotion(mediaQueryList.matches);

        handleChange();
        mediaQueryList.addEventListener('change', handleChange);
        return () => mediaQueryList.removeEventListener('change', handleChange);
    }, []);

    return prefersReducedMotion;
};
